<template>
  <b-modal
    id="modal-edit-remarks"
    modal-class="status-update-modal"
    centered
    no-close-on-backdrop
    title="Edit Remarks"
    @ok="save"
    @hidden="resetRemarks"
  >
    <b-form-textarea
      v-model="remarksValue"
      placeholder="Optional"
      rows="6"
      no-resize
    />

    <template #modal-footer="{ ok, cancel }">
      <b-button
        variant="flat-primary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="success"
        @click="ok()"
      >
        Save Changes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import {
  BModal, BButton, BFormTextarea,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
    BFormTextarea,
  },
  props: {
    remarks: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      remarksValue: this.remarks,
    }
  },
  watch: {
    remarks(val) {
      this.remarksValue = val
    },
  },
  methods: {
    resetRemarks() {
      this.remarksValue = this.remarks
    },
    save() {
      this.$emit('save', this.remarksValue)
    },
  },
}
</script>
